import { getAccessToken } from "../Services/authToken";

export interface RescheduleSlotPanelResponse {
  success: boolean;
  message: string;
}

const hostname = window.location.hostname;

const getBaseUrl = (): string => {
  if (hostname.includes('localhost')) return 'http://localhost:8080';
  if (hostname.includes('dev')) return 'https://candidateinterviewscheduler-dev.pwc.com';
  if (hostname.includes('stg') || hostname.includes('stage')) return 'https://candidateinterviewscheduler-stg.pwc.com';
  return 'https://candidateinterviewscheduler.pwc.com';
};

export async function rescheduleInterviewSlotPanel(
  slotId: string,
  reason: string
): Promise<RescheduleSlotPanelResponse> {
  const baseurl = getBaseUrl();
  const token = await getAccessToken();
  if (!token) throw new Error('Authentication required - please log in');

  const res = await fetch(`${baseurl}/api/candidate-dashboard/reschedule-slot-panel`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ slotId, cancellation_reason: reason }),
  });

  if (!res.ok) {
    const errorBody = await res.text();
    throw new Error(`Panel reschedule failed: ${res.statusText} - ${errorBody}`);
  }

  return res.json();
}

export async function sendPanelRescheduleEmail(
  slot: any,
  candidateEmail: string,
  reason: string
): Promise<any> {
  const baseurl = getBaseUrl();
  const token = await getAccessToken();
  if (!token) throw new Error('Authentication required - please log in');

  const panelPairing = slot?.pairing as any;

  const interviewerSlots = [
    { interviewer_email: panelPairing?.interviewer_1_id, interviewer_name: panelPairing?.interviewer_1_name },
    { interviewer_email: panelPairing?.interviewer_2_id, interviewer_name: panelPairing?.interviewer_2_name },
    { interviewer_email: panelPairing?.interviewer_3_id, interviewer_name: panelPairing?.interviewer_3_name },
    { interviewer_email: panelPairing?.interviewer_4_id, interviewer_name: panelPairing?.interviewer_4_name },
    { interviewer_email: panelPairing?.interviewer_5_id, interviewer_name: panelPairing?.interviewer_5_name },
  ].filter(i => i.interviewer_email && i.interviewer_name);

  const reqId = slot?.pairing?.requisition_id || slot?.requisition_id || 'N/A';
  const jobTitle = `${reqId} ${slot?.job_title || 'N/A'}`;

  const payload = {
    email_type: 'panel_interview_reschedule',
    additional_data: {
      candidate_email: candidateEmail,
      candidate_name: panelPairing?.candidate_full_name,
      job_title: jobTitle,
      panel_start_time: new Date(panelPairing?.start_time).toISOString(),
      panel_end_time: new Date(panelPairing?.end_time).toISOString(),
      panel_interview_type: panelPairing?.interview_1_type,
      interviewer_slots: interviewerSlots,
      interview_date: new Date(panelPairing?.start_time).toISOString().split('T')[0],
      reschedule_reason: reason,
      send_to_candidate: false,
      send_to_interviewers: true,
      send_to_recruiter: true,
      recruiter_email: panelPairing?.recruiter_email,
      recruiter_name: panelPairing?.recruiter_name,
      campus_hire: false,
      experienced_hire: true,
    },
  };

  console.log('[sendPanelRescheduleEmail] Payload for panel reschedule:', JSON.stringify(payload, null, 2));

  const res = await fetch(`${baseurl}/api/communications/emails`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const errorBody = await res.text();
    throw new Error(`Panel reschedule email failed: ${res.statusText} - ${errorBody}`);
  }

  return res.json();
}